import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { PartnerService } from '../../shared/services/partner.service';
import { StateService } from '../../products/services/state.service';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private formBuilder = inject(FormBuilder);
  private userService = inject(UserService);
  private partnerService = inject(PartnerService);

  form = this.formBuilder.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  readonly maintenanceModel = inject(StateService).maintenanceModel;
  loading = false;
  loginError?: string;

  ngOnInit(): void {
    if (this.userService.isAuthenticated()) {
      if (this.userService.isAdmin()) {
        window.location.replace('/Admin');
      }
      else {
        this.redirectAfterLogin();
      }
    }

    this.route.url.subscribe(params => {
      const partnerCode = params[1]?.path;
      if (partnerCode != undefined) {
        this.partnerService.setPartner(partnerCode);
      }
    });
  }

  onLogin() {
    this.loading = true;
    this.loginError = undefined;
    this.userService.login(this.form.value.username!, this.form.value.password!)
      .subscribe({
        next: (result) => {
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          this.loginError = 'Email or password is invalid';
        }
      });
  }

  private redirectAfterLogin() {
    const redirectUrl = sessionStorage.getItem('redirectUrl');
    
    if (redirectUrl) {
      sessionStorage.removeItem('redirectUrl');
      this.router.navigateByUrl(redirectUrl);
    } else if (this.userService.redirectUrl) {
      const url = this.userService.redirectUrl;
      this.userService.redirectUrl = "";
      this.router.navigateByUrl(url);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
}